import { render } from "./PopUpJeu.vue?vue&type=template&id=d26431e0"
import script from "./PopUpJeu.vue?vue&type=script&lang=js"
export * from "./PopUpJeu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__